// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"company_formLabel__3DUmV","grayImage":"company_grayImage__2O78I"};